import {
  LOGGED_IN,
  LOGGED_OUT,
  LOGGING_IN,
  LOGIN_ERROR,
} from "./types";

const INITIAL_STATE = {
  logged_in: false,
  data: undefined,
  loading: false,
  error: false,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGGING_IN:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case LOGGED_IN:
      return {
        ...state,
        logged_in: true,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case LOGGED_OUT:
      return {
        ...state,
        logged_in: false,
        data: undefined,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        data: undefined,
        error: action.payload.data,
      };
    default:
      return state;
  }
};

export default reducer;
